var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "800" },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-card",
        [
          _c("v-card-title", { staticClass: "headline" }, [
            _vm._v("Solicitud - Técnica - Solicitud Equipos para stock")
          ]),
          _c("v-divider"),
          _c("v-card-text", [
            _c(
              "p",
              [
                _c("b", [_vm._v("N° Caso: ")]),
                _vm._v(_vm._s(_vm.item.num_solicitud)),
                _c("br"),
                _c("b", [_vm._v("Patente: ")]),
                _vm._v(_vm._s(_vm.item.patente)),
                _c("br"),
                _c("b", [_vm._v("Fecha creacion: ")]),
                _vm._v(_vm._s(_vm.item.fecha_creacion)),
                _c("br"),
                _c("b", [_vm._v("Ejecutivo de cuenta: ")]),
                _vm._v(_vm._s(_vm.item.ejecutivo)),
                _c("br"),
                _c("b", [_vm._v("Estado: ")]),
                _vm._v(_vm._s(_vm.item.estado)),
                _c("br"),
                _c("b", [_vm._v("Descripción: ")]),
                _c(
                  "v-container",
                  { attrs: { fluid: "", "grid-list-md": "" } },
                  [
                    _c("v-textarea", {
                      attrs: {
                        name: "input-7-1",
                        box: "",
                        disabled: "",
                        "auto-grow": "",
                        value: _vm.item.descripcion
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _c("v-card-title", { staticClass: "headline" }, [
            _vm._v("Adjuntar documento")
          ]),
          _c(
            "v-card-text",
            [
              _c(
                "v-container",
                { attrs: { "grid-list-md": "", "text-xs-left": "" } },
                [
                  _c(
                    "v-layout",
                    { attrs: { row: "", wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs6: "" } },
                        [
                          _vm._v("\n            Comentarios"),
                          _c("span", { staticStyle: { color: "red" } }, [
                            _vm._v("*")
                          ]),
                          _c("v-textarea", {
                            attrs: { name: "input-7-1", value: "", hint: "" },
                            model: {
                              value: _vm.comentario,
                              callback: function($$v) {
                                _vm.comentario = $$v
                              },
                              expression: "comentario"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { xs6: "" } },
                        [
                          _vm._v("\n            Documentos\n            "),
                          _c(
                            "v-list",
                            { attrs: { "two-line": "", subheader: "" } },
                            _vm._l(_vm.item.documentos, function(i) {
                              return _c(
                                "v-list-tile",
                                { key: i.NombreDoc, attrs: { avatar: "" } },
                                [
                                  _c(
                                    "v-list-tile-content",
                                    [
                                      _c("v-list-tile-title", [
                                        _vm._v(_vm._s(i.NombreDoc))
                                      ]),
                                      _c("v-list-tile-sub-title", [
                                        _vm._v(_vm._s(i.FechaCreacion))
                                      ])
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-list-tile-action",
                                    [
                                      _c(
                                        "v-btn",
                                        { attrs: { icon: "" } },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              attrs: { color: "blue darken-2" },
                                              on: {
                                                click: function($event) {
                                                  return _vm.descargar(
                                                    i.LstNotas[0].IdNota
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v("file_download")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-layout",
                    { attrs: { row: "", wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs6: "" } },
                        [
                          _vm._v("\n            Agregar archivo"),
                          _c("span", { staticStyle: { color: "red" } }, [
                            _vm._v("*")
                          ]),
                          _c("v-text-field", {
                            attrs: {
                              label: "Elegir archivo...",
                              "prepend-icon": "attach_file",
                              clearable: ""
                            },
                            on: { click: _vm.onPickFile },
                            model: {
                              value: _vm.fileName,
                              callback: function($$v) {
                                _vm.fileName = $$v
                              },
                              expression: "fileName"
                            }
                          }),
                          _c("input", {
                            ref: "fileInput",
                            staticStyle: { display: "none" },
                            attrs: { type: "file", accept: "*/*" },
                            on: { change: _vm.onFilePicked }
                          }),
                          _c("v-spacer"),
                          _c(
                            "v-btn",
                            {
                              staticClass: "black--text",
                              attrs: { color: "warning" },
                              on: {
                                click: function($event) {
                                  return _vm.subirDoc()
                                }
                              }
                            },
                            [
                              _vm._v("Subir archivo "),
                              _c("v-icon", { attrs: { right: "", dark: "" } }, [
                                _vm._v("cloud_upload")
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("v-divider"),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  staticClass: "black--text",
                  attrs: { color: "warning" },
                  on: {
                    click: function($event) {
                      return _vm.$emit("close", false)
                    }
                  }
                },
                [
                  _vm._v("\n        Exportar a Excel\n        "),
                  _c("v-icon", { attrs: { right: "", dark: "" } }, [
                    _vm._v("description")
                  ])
                ],
                1
              ),
              _c(
                "v-btn",
                {
                  staticClass: "white--text",
                  attrs: { color: "red" },
                  on: {
                    click: function($event) {
                      return _vm.$emit("close", false)
                    }
                  }
                },
                [_vm._v("\n        Cerrar\n      ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }